// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"64":"4798b7fe","769":"63c2e9df"}[chunkId] + ".chunk.css";
};